<template>
  <v-navigation-drawer
    v-if="!noDrawer"
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-breakpoint="960"
    app
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-divider class="mb-1" />

    <v-list
      dense
      nav
    >
      <v-list-item>
        <v-list-item-avatar
          class="align-self-center"
          color="white"
          contain
        >
          <v-img
            contain
            min-width="43"
            min-height="43"
            :src="DefaultUrl"
          />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            class="text-h4"
            v-text="profile.title"
          />
          Revelio Planning
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="mb-2" />

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>

    <!-- <template v-slot:append>
      <base-item
        :item="{
          title: $t('upgrade'),
          icon: 'mdi-package-up',
          to: '/upgrade',
        }"
      />
    </template> -->
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  /* eslint-disable */
  import {
    mapState,
  } from 'vuex'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      // superUserItems: [
      //   {
      //     title: 'OP24 For International',
      //     icon: 'mdi-clipboard-text',
      //     to: '/op/tables/op',
      //   },
      //   {
      //     title: 'OP24 For CI',
      //     icon: 'mdi-clipboard-text',
      //     to: '/op/tables/ci-op',
      //   },
      //   {
      //     title: 'OP24 For Bases',
      //     icon: 'mdi-clipboard-text',
      //     to: '/op/tables/bases-op',
      //   },
      //   {
      //     title: 'View Data For International',
      //     icon: 'mdi-table-large-plus',
      //     to: '/op/tables/viewdata',
      //   },
      //   {
      //     title: 'View Data For CI',
      //     icon: 'mdi-table-large-plus',
      //     to: '/op/tables/ci-viewdata',
      //   },
      //   {
      //     title: 'View Data For Bases',
      //     icon: 'mdi-table-large-plus',
      //     to: '/op/tables/bases-viewdata',
      //   },
      //   {
      //     title: 'Setting For International',
      //     icon: 'mdi-cog',
      //     to: '/op/tables/setting',
      //   },
      //   {
      //     title: 'Setting For CI',
      //     icon: 'mdi-cog',
      //     to: '/op/tables/ci-setting',
      //   },
      //   {
      //     title: 'Setting For Bases',
      //     icon: 'mdi-cog',
      //     to: '/op/tables/bases-setting',
      //   },
      //   {
      //     title: 'Access Control',
      //     icon: 'mdi-account-settings',
      //     to: '/op/access/role',
      //   },
      //   {
      //     title: 'Client Details',
      //     icon: 'mdi-account-details-outline',
      //     to: '/op/tables/client-details',
      //   },
      //   {
      //     title: 'History',
      //     icon: 'mdi-account-details-outline',
      //     to: '/op/tables/history',
      //   },
      //   {
      //     title: 'Download Center',
      //     icon: 'mdi-download',
      //     to: '/op/tables/download-center',
      //   },
      // ],
      // adminItems: [
      //   // {
      //   //   title: '3 Years Plan',
      //   //   icon: 'mdi-clipboard-text',
      //   //   to: '/op/tables/op_v1',
      //   // },
      //   {
      //     title: 'OP24',
      //     icon: 'mdi-clipboard-text',
      //     to: '/op/tables/op',
      //   },
      //   {
      //     title: 'View Data',
      //     icon: 'mdi-table-large-plus',
      //     to: '/op/tables/viewdata',
      //   },
      //   // {
      //   //   title: 'Setting',
      //   //   icon: 'mdi-cog',
      //   //   to: '/op/tables/setting',
      //   // },
      //   {
      //     title: 'Access Control',
      //     icon: 'mdi-account-settings',
      //     to: '/op/access/role',
      //   },
      //   // {
      //   //   title: 'Summary',
      //   //   icon: 'mdi-plus-box',
      //   //   to: '/op/tables/summary',
      //   // },
      //   {
      //     title: 'Client Details',
      //     icon: 'mdi-account-details-outline',
      //     to: '/op/tables/client-details',
      //   },
      //   {
      //     title: 'History',
      //     icon: 'mdi-account-details-outline',
      //     to: '/op/tables/history',
      //   },
      //   {
      //     title: 'Download Center',
      //     icon: 'mdi-download',
      //     to: '/op/tables/download-center',
      //   },
      //   // {
      //   //   title: 'Black Box Upload',
      //   //   icon: 'mdi-account-details-outline',
      //   //   to: '/op/tables/blackboxupload',
      //   // },
      //   // {
      //   //   title: 'Mass Upload',
      //   //   icon: 'mdi-cog',
      //   //   to: '/op/tables/massupload',
      //   // },
      // ],
      // notAdItems: [
      //   // {
      //   //   title: '3 Years Plan',
      //   //   icon: 'mdi-clipboard-text',
      //   //   to: '/op/tables/op_v1',
      //   // },
      //   {
      //     title: 'OP24',
      //     icon: 'mdi-clipboard-text',
      //     to: '/op/tables/op',
      //   },
      //   {
      //     title: 'View Data',
      //     icon: 'mdi-table-large-plus',
      //     to: '/op/tables/viewdata',
      //   },
      //   // {
      //   //   title: 'Summary',
      //   //   icon: 'mdi-plus-box',
      //   //   to: '/op/tables/summary',
      //   // },
      //   {
      //     title: 'Client Details',
      //     icon: 'mdi-account-details-outline',
      //     to: '/op/tables/client-details',
      //   },
      //   {
      //     title: 'Download Center',
      //     icon: 'mdi-download',
      //     to: '/op/tables/download-center',
      //   },
      //   // {
      //   //   title: 'Summary',
      //   //   icon: 'mdi-table-large-plus',
      //   //   to: '/op/tables/summary',
      //   // },
      //   // {
      //   //   title: 'Setting',
      //   //   icon: 'mdi-table-large-plus',
      //   //   to: '/op/tables/setting',
      //   // },
      // ],
      items: [
        {
          title: 'OP25',
          icon: 'mdi-clipboard-text',
          group: '/op/tables',
          children: [
            {
              roleLvs: ['-1', '0', '1', '2', '3'],
              typelv: 1,
              title: 'NIQ',
              to: 'op',
            },
            {
              roleLvs: ['-1', '0', '1', '2', '3'],
              typelv: 2,
              title: 'GFK',
              to: 'ci-op',
            },
            // {
            //   roleLvs: ['0', '1', '2', '3'],
            //   typelv: 3,
            //   title: 'Bases',
            //   to: 'bases-op',
            // },
          ]
        },
        {
          // rolelv: 1,
          title: 'View Data',
          icon: 'mdi-table-large-plus',
          group: '/op/tables',
          children: [
            {
              roleLvs: ['-1', '0', '1', '2', '3'],
              typelv: 1,
              title: 'NIQ',
              to: 'viewdata',
            },
            {
              roleLvs: ['-1', '0', '1', '2', '3'],
              typelv: 2,
              title: 'GFK',
              to: 'ci-viewdata',
            },
            // {
            //   roleLvs: ['0', '1', '2', '3'],
            //   typelv: 3,
            //   title: 'Bases',
            //   to: 'bases-viewdata',
            // },
          ]
        },
        {
          // rolelv: 3,
          title: 'Setting',
          icon: 'mdi-cog',
          group: '/op/tables',
          children: [
            {
              roleLvs: ['-1', '0'],
              typelv: 1,
              title: 'NIQ',
              to: 'setting',
            },
            {
              roleLvs: ['-1', '0'],
              typelv: 2,
              title: 'GFK',
              to: 'ci-setting',
            },
            // {
            //   roleLvs: ['0'],
            //   typelv: 3,
            //   title: 'Bases',
            //   to: 'bases-setting',
            // },
          ]
        },
        {
          title: 'Maintenance',
          icon: 'mdi-cog-outline',
          group: '/op/tables',
          children: [
            {
              roleLvs: ['-1'],
              typelv: 1,
              title: 'Maintenance',
              to: 'maintenance',
            },
          ]
        },
        // aim
        {
          title: 'AIM NIQ',
          icon: 'mdi-target',
          group: '/op/tables',
          children: [
            {
              roleLvs: ['-1', '0'],
              typelv: 1,
              title: 'AIM',
              to: 'aim',
            },
          ]
        },
        {
          // rolelv: 2,
          title: 'Access Control',
          icon: 'mdi-account-settings',
          group: '/op/access',
          children: [
            {
              roleLvs: ['-1', '0', '1'],
              typelv: 1,
              title: 'NIQ',
              to: 'role',
            },
            {
              roleLvs: ['-1', '0', '1'],
              typelv: 2,
              title: 'GFK',
              to: 'ci-role',
            },
            // {
            //   roleLvs: ['0', '1'],
            //   typelv: 3,
            //   title: 'Bases',
            //   to: 'bases-role',
            // },
          ]
        },
        // 2024.8.5 comment
        // hide client detail
        {
          // rolelv: 1,
          roleLvs: ['-1', '0', '1', '2', '3'],
          typelv: 0,
          title: 'Client Details',
          icon: 'mdi-account-details-outline',
          to: '/op/tables/client-details',
        },
        // {
        //   // rolelv: 2,
        //   roleLvs: ['-1', '0', '1', '2'],
        //   typelv: 0,
        //   title: 'History',
        //   icon: 'mdi-account-details-outline',
        //   to: '/op/tables/history',
        // },
        {
          // rolelv: 1,
          roleLvs: ['-1', '0', '1', '2', '3'],
          typelv: 0,
          title: 'Download Center',
          icon: 'mdi-download',
          to: '/op/tables/download-center',
        },
      ],
      DefaultUrl: require('@/assets/RF new.png'),
    }),

    computed: {
      ...mapState(['barColor', 'barImage', 'user']),
      drawerVuex: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      computedItems () {
        // let showItems = ''
        // for (const hd of this.items) {
        //   if (hd.typelv === 0) {
        //     showItems.push(hd)
        //   } else if (hd.typelv === 1) {
        //     if (this.user.Role === '0' && hd.rolelv < 4) {
        //       showItems.push(hd)
        //     }
        //     if (this.user.Role === '1' && hd.rolelv < 3) {
        //       showItems.push(hd)
        //     }
        //     if ((this.user.Role === '2' || this.user.Role === '3') && hd.rolelv < 2) {
        //       showItems.push(hd)
        //     }
        //   } else if (hd.typelv === 2) {
        //     if (this.user.ci_Role === '0' && hd.rolelv < 4) {
        //       showItems.push(hd)
        //     }
        //     if (this.user.ci_Role === '1' && hd.rolelv < 3) {
        //       showItems.push(hd)
        //     }
        //     if ((this.user.ci_Role === '2' || this.user.ci_Role === '3') && hd.rolelv < 2) {
        //       showItems.push(hd)
        //     }
        //   } else if (hd.typelv === 3) {
        //     if (this.user.bases_Role === '0' && hd.rolelv < 4) {
        //       showItems.push(hd)
        //     }
        //     if (this.user.bases_Role === '1' && hd.rolelv < 3) {
        //       showItems.push(hd)
        //     }
        //     if ((this.user.bases_Role === '2' || this.user.bases_Role === '3') && hd.rolelv < 2) {
        //       showItems.push(hd)
        //     }
        //   }
        // }
        // this.showItem(this.items)
        return this.items.filter(this.filterItem).map(this.mapItem)
      },
      profile () {
        return {
          avatar: true,
          title: this.$t('avatar'),
        }
      },
      noDrawer () {
        return this.$route.meta.noDrawer
      },
      drawer () {
        return !!(this.drawerVuex && !this.noDrawer)
      }
    },

    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.filter(this.filterItem).map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },

      filterItem (item) {
        if (item.children) {
          let show = false
          for (const hd of item.children) {
            show = show || this.filterItem(hd)
          }
          return show
        } else {
          let roles = []
          switch (item.typelv) {
            case 0:
              roles.push(this.user.Role, this.user.ci_Role, this.user.bases_Role)
              break;
            case 1:
              roles.push(this.user.Role)
              break;
            case 2:
              roles.push(this.user.ci_Role)
              break;
            case 3:
              roles.push(this.user.bases_Role)
              break;
          }
          return !!roles.filter(el => item.roleLvs.includes(el)).length
          // if (item.typelv === 0) {
          //   showItems.push(item)
          // } else if (item.typelv === 1) {
          //   if (this.user.Role === '0' && item.rolelv < 4) {
          //     showItems.push(item)
          //   }
          //   if (this.user.Role === '1' && item.rolelv < 3) {
          //     showItems.push(item)
          //   }
          //   if ((this.user.Role === '2' || this.user.Role === '3') && item.rolelv < 2) {
          //     showItems.push(item)
          //   }
          // } else if (item.typelv === 2) {
          //   if (this.user.ci_Role === '0' && item.rolelv < 4) {
          //     showItems.push(item)
          //   }
          //   if (this.user.ci_Role === '1' && item.rolelv < 3) {
          //     showItems.push(item)
          //   }
          //   if ((this.user.ci_Role === '2' || this.user.ci_Role === '3') && item.rolelv < 2) {
          //     showItems.push(item)
          //   }
          // } else if (item.typelv === 3) {
          //   if (this.user.bases_Role === '0' && item.rolelv < 4) {
          //     showItems.push(item)
          //   }
          //   if (this.user.bases_Role === '1' && item.rolelv < 3) {
          //     showItems.push(item)
          //   }
          //   if ((this.user.bases_Role === '2' || this.user.bases_Role === '3') && item.rolelv < 2) {
          //     showItems.push(item)
          //   }
          // }
        }
      },
      // showItem (item) {
      //   for (const hd of item) {
      //     if (hd.typelv === 0) {
      //       showItems.push(hd)
      //     } else if (hd.typelv === 1) {
      //       if (this.user.Role === '0' && hd.rolelv < 4) {
      //         showItems.push(hd)
      //       }
      //       if (this.user.Role === '1' && hd.rolelv < 3) {
      //         showItems.push(hd)
      //       }
      //       if ((this.user.Role === '2' || this.user.Role === '3') && hd.rolelv < 2) {
      //         showItems.push(hd)
      //       }
      //     } else if (hd.typelv === 2) {
      //       if (this.user.ci_Role === '0' && hd.rolelv < 4) {
      //         showItems.push(hd)
      //       }
      //       if (this.user.ci_Role === '1' && hd.rolelv < 3) {
      //         showItems.push(hd)
      //       }
      //       if ((this.user.ci_Role === '2' || this.user.ci_Role === '3') && hd.rolelv < 2) {
      //         showItems.push(hd)
      //       }
      //     } else if (hd.typelv === 3) {
      //       if (this.user.bases_Role === '0' && hd.rolelv < 4) {
      //         showItems.push(hd)
      //       }
      //       if (this.user.bases_Role === '1' && hd.rolelv < 3) {
      //         showItems.push(hd)
      //       }
      //       if ((this.user.bases_Role === '2' || this.user.bases_Role === '3') && hd.rolelv < 2) {
      //         showItems.push(hd)
      //       }
      //     }
      //   }
      //   return showItems
      // },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
